// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
[matTooltip] {
  /* Hide any native title tooltips */
}
[matTooltip] title {
  display: none !important;
}

.mat-icon-button {
  padding: 0;
}

.user-component {
  display: grid;
  grid-template-columns: 1fr auto;
  /* or minmax(0, auto) 1fr */
  /* ← important: give the grid container height! */
  /* optional */
}
.user-component .mat-fab.mat-button-base {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}
.user-component .mat-fab.mat-button-base.arrow-back {
  bottom: unset;
  right: unset;
  top: 1rem;
  right: 1rem;
}

.user-component {
  height: calc(100vh - --header-height);
  display: grid;
  grid-template-rows: auto 1fr;
}
.user-component .errors {
  color: var(--color-error);
  font-size: var(--font-size-medium);
}

.user-maintenance-content {
  padding-inline: 1rem;
  padding-block: 0.5rem;
}
.user-maintenance-content .user-list {
  overflow-y: scroll;
  height: calc(100vh - --header-height - 1rem);
}
.user-maintenance-content .user-list mat-header-cell {
  font-weight: 900;
  background-color: rgb(243, 242, 241);
}
.user-maintenance-content .selected-user {
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 1rem;
}
.user-maintenance-content .selected-user .box.user-form {
  padding-top: 2rem;
}
.user-maintenance-content .form-field {
  font-size: inherit;
  font-weight: 400;
  line-height: 1.125;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  letter-spacing: normal;
  padding-top: 0.5em;
  padding-right: 0px;
  padding-bottom: 1.25em;
  padding-left: 0px;
}

.selected-row,
.mat-row:hover .mat-cell {
  background-color: rgb(243, 242, 241);
}

.mat-row {
  min-height: 2rem;
}

.mat-header-row {
  min-height: 2.5rem;
}

.user-form {
  margin-block-start: 10px;
  min-width: 40ch;
}
.user-form .buttons {
  display: flex;
  justify-content: flex-end;
  padding-block-start: 1rem;
}
.user-form .admin {
  display: flex;
}
.user-form .admin .label {
  flex-grow: 1;
}
.user-form .sources {
  display: grid;
  max-height: 100%;
}
.user-form form {
  display: grid;
}`, "",{"version":3,"sources":["webpack://./src/app/components/user/user.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAOhB;EAKI,mCAAA;AATJ;AAKI;EACI,wBAAA;AAHR;;AASA;EACI,UAAA;AANJ;;AASA;EACI,aAAA;EACA,+BAAA;EACA,2BAAA;EACA,iDAAA;EAEA,aAAA;AAPJ;AAUI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AARR;AAUQ;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AARZ;;AAaA;EACI,qCAtCoB;EAuCpB,aAAA;EACA,4BAAA;AAVJ;AAYI;EACI,yBAAA;EACA,kCAAA;AAVR;;AAcA;EAEI,oBAAA;EACA,qBAFgB;AAVpB;AAcI;EACI,kBAAA;EACA,4CAAA;AAZR;AAcQ;EACI,gBAAA;EACA,oCAAA;AAZZ;AAgBI;EACI,aAAA;EACA,oCAAA;EACA,SAAA;AAdR;AAgBQ;EACI,iBAAA;AAdZ;AAkBI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAhBR;;AAsBA;;EAEI,oCAAA;AAnBJ;;AAsBA;EACI,gBAAA;AAnBJ;;AAsBA;EACI,kBAAA;AAnBJ;;AAsBA;EACI,wBAAA;EACA,eAAA;AAnBJ;AAqBI;EACI,aAAA;EACA,yBAAA;EACA,yBAAA;AAnBR;AAuBI;EACI,aAAA;AArBR;AAuBQ;EACI,YAAA;AArBZ;AAyBI;EACI,aAAA;EACA,gBAAA;AAvBR;AA0BI;EACI,aAAA;AAxBR","sourcesContent":["// Move these 2 values to a shared Sass file for re-use\n\n$parent-height: calc(var(--header-height) + var(--toolbar-height));\n$parent-height: --header-height;\n\n$user-component-height: calc(100vh - $parent-height);\n\n[matTooltip] {\n    title {\n        display: none !important;\n    }\n\n    /* Hide any native title tooltips */\n}\n\n.mat-icon-button {\n    padding: 0;\n}\n\n.user-component {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    /* or minmax(0, auto) 1fr */\n    /* ← important: give the grid container height! */\n    // gap: 1rem;\n    /* optional */\n\n\n    .mat-fab.mat-button-base {\n        position: absolute;\n        bottom: 1rem;\n        right: 1rem;\n\n        &.arrow-back {\n            bottom: unset;\n            right: unset;\n            top: 1rem;\n            right: 1rem;\n        }\n    }\n}\n\n.user-component {\n    height: $user-component-height;\n    display: grid;\n    grid-template-rows: auto 1fr;\n\n    .errors {\n        color: var(--color-error);\n        font-size: var(--font-size-medium);\n    }\n}\n\n.user-maintenance-content {\n    $padding-block: 0.5rem;\n    padding-inline: 1rem;\n    padding-block: $padding-block;\n\n    .user-list {\n        overflow-y: scroll;\n        height: calc($user-component-height - ($padding-block * 2));\n\n        mat-header-cell {\n            font-weight: 900;\n            background-color: rgb(243, 242, 241);\n        }\n    }\n\n    .selected-user {\n        display: grid;\n        grid-template-columns: auto auto 1fr;\n        gap: 1rem;\n\n        .box.user-form {\n            padding-top: 2rem;\n        }\n    }\n\n    .form-field {\n        font-size: inherit;\n        font-weight: 400;\n        line-height: 1.125;\n        font-family: Roboto, \"Helvetica Neue\", sans-serif;\n        letter-spacing: normal;\n        padding-top: 0.5em;\n        padding-right: 0px;\n        padding-bottom: 1.25em;\n        padding-left: 0px;\n    }\n\n\n}\n\n.selected-row,\n.mat-row:hover .mat-cell {\n    background-color: rgb(243, 242, 241);\n}\n\n.mat-row {\n    min-height: 2rem;\n}\n\n.mat-header-row {\n    min-height: 2.5rem;\n}\n\n.user-form {\n    margin-block-start: 10px;\n    min-width: 40ch;\n\n    .buttons {\n        display: flex;\n        justify-content: flex-end;\n        padding-block-start: 1rem;\n\n    }\n\n    .admin {\n        display: flex;\n\n        .label {\n            flex-grow: 1;\n        }\n    }\n\n    .sources {\n        display: grid;\n        max-height: 100%;\n    }\n\n    form {\n        display: grid;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
